export default __webpack_public_path__ + "static/media/youtube (1).6dbc264a.svg";